import api from "../services/api";
import { IServiceResponse } from "../types/api";
import {
  IPromoCode,
  IPromoCodeValidationRequest,
  IPromoCodeValidationResponse,
  ICreatePromoCodeDTO,
  IUpdatePromoCodeDTO,
} from "../models/IPromoCode";

/**
 * Validate a promo code for a specific tournament (Public endpoint)
 */
export const validatePromoCode = (
  request: IPromoCodeValidationRequest
): Promise<IServiceResponse<IPromoCodeValidationResponse>> => api.post("PromoCode/validate", request);

/**
 * Get a specific promo code by ID (Admin only)
 */
export const getPromoCodeById = (id: string): Promise<IServiceResponse<IPromoCode>> =>
  api.get(`PromoCode/${id}`);

/**
 * Get all promo codes for a specific tournament (Admin only)
 */
export const getPromoCodesByTournament = (
  tournamentId: string
): Promise<IServiceResponse<IPromoCode[]>> => api.get(`PromoCode/tournament/${tournamentId}`);

/**
 * Create a new promo code (Admin only)
 */
export const createPromoCode = (data: ICreatePromoCodeDTO): Promise<IServiceResponse<IPromoCode>> =>
  api.post("PromoCode", data);

/**
 * Update an existing promo code (Admin only)
 */
export const updatePromoCode = (id: string, data: IUpdatePromoCodeDTO): Promise<IServiceResponse<IPromoCode>> =>
  api.put(`PromoCode/${id}`, data);

/**
 * Delete a promo code (Admin only)
 */
export const deletePromoCode = (id: string): Promise<IServiceResponse<boolean>> => api.delete(`PromoCode/${id}`);

